import { FastField, Field } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import { useTranslation } from 'react-i18next';
import { Row, Col, Modal } from 'react-bootstrap';
import { useMemo, useState } from 'react';
import KTBSButton, { KTBSButtonColor, KTBSButtonSize, KTBSButtonType } from 'general/components/OtherKeenComponents/KTBSButton';
import UIHelper from 'general/helpers/UIHelper';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import CustomDropdown from 'general/components/Others/CustomDropdown';
import Utils from 'general/utils/Utils';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';

function SaleCommissionView({
    formikProps,
    commissionRateSale,
    commissionModeList,
    commissionUnit,
    setCommissionUnit,
    isEnergyCommissionOn,
    handleToggle,
    selectedChargeStation,
    setSelectedChargeStation,
    readyToValidData,
}) {
    const { t } = useTranslation();
    const handleAddSaleCommission = (values, setFieldValue) => {
        const nextId = values.saleCommission[values.saleCommission.length - 1].id + 1;
        const updatedSaleCommission = [
            ...values.saleCommission,
            { id: nextId, revenue: 0, discount: 0 },
        ];

        setFieldValue('saleCommission', updatedSaleCommission);
    };

    const handleDeleteSaleCommission = (id, values, setFieldValue) => {
        const updatedSaleCommission = values.saleCommission.filter((bonus) => bonus.id !== id);
        if (updatedSaleCommission.length === 0) {
            setFieldValue('saleCommission', [{ id: 0, revenue: 0, discount: 0 }]);
        } else {
            setFieldValue('saleCommission', updatedSaleCommission);
        }
    };


    const handleSetCommissionUnit = (value) => {
        const unit = DealerHelper.checkPercentCommissionMode(value) ? '%' : 'VNĐ/kWh';
        setCommissionUnit(unit);
    };

    const dropdownChargeStationEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="stationId"
                name="stationId"
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                            ${!isEnergyCommissionOn ? 'disabled' : ''}
                            ${readyToValidData && isEnergyCommissionOn && !selectedChargeStation ? 'button-invalid' : ''}`}
                        type="button"
                    >
                        {selectedChargeStation?.name ?? 'Tất cả'}
                    </button>
                }
                selectedValue={selectedChargeStation}
                subTitleType="address"
                dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
                getSubItems={async (item) => {
                    return ChargeHelper.API.requestGetChargeStationList({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                    }).then((data) => {
                        return {
                            values: data.chargeStations?.map((station) => ({
                                id: station?.stationId,
                                name: station?.name,
                                item: station,
                                address: ChargeHelper.Utils.getChargeStationFullAddress(station),
                            })),
                            total: data.total,
                        };
                    });
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargeStation(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                ignoreConfirmClick={true}
                defaultValue={{
                    name: 'Trạm sạc',
                    role: 'STATION',
                }}
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedChargeStation(null);
                        })}
                    </div>
                }
                disabled={!isEnergyCommissionOn}
            />
        )
    }, [selectedChargeStation, readyToValidData, isEnergyCommissionOn])

    return (
        <Row>
            <Col md={12}>
                <Modal.Title className="mb-3 pt-0">
                    <span
                        className="font-weight-bolder"
                        style={{ fontSize: 18, color: AppColors.gray[900] }}
                    >
                        Hoa hồng bán nhượng quyền
                    </span>
                </Modal.Title>
            </Col>
            {commissionRateSale && (
                <Col md={4} className="pr-0">
                    <KTFormGroup
                        label={
                            <span
                                className="font-weight-boldest"
                                style={{
                                    fontSize: 13,
                                    color: AppColors.gray[800],
                                }}
                            >
                                {t('Tỷ lệ hoa hồng')}
                            </span>
                        }
                        inputName={`saleCommission[0].discount`}
                        additionalClassName=" mb-3"
                        inputElement={
                            <FastField name={`saleCommission[0].discount`}>
                                {({ field, form, meta }) => {
                                    return (
                                        <KTFormInput
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                                form.setFieldValue(field.name, value);
                                            }}
                                            onBlur={() => {
                                                form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid
                                            type={KTFormInputType.number}
                                            placeholder={'Nhập số'}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            unit="%"
                                        />
                                    );
                                }}
                            </FastField>
                        }
                    // isRequired={true}
                    />
                </Col>
            )}
            {formikProps.values.saleCommission.slice(1)?.map((discount, index) => (
                <div key={index + 1}>
                    <Row>
                        <Col md={7} className="pr-0" style={{ paddingLeft: 15 }}>
                            <KTFormGroup
                                label={
                                    <span
                                        className="font-weight-boldest"
                                        style={{
                                            fontSize: 13,
                                            color: AppColors.gray[800],
                                        }}
                                    >
                                        {t('Doanh thu đạt mức')}{' '}
                                    </span>
                                }
                                inputName={`saleCommission[${index + 1}].revenue`}
                                additionalClassName="mb-3"
                                inputElement={
                                    <FastField name={`saleCommission[${index + 1}].revenue`}>
                                        {({ field, form, meta }) => {
                                            return (
                                                <KTFormInput
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={(value) => {
                                                        form.setFieldValue(field.name, value);
                                                    }}
                                                    onBlur={() => {
                                                        form.setFieldTouched(field.name, true);
                                                    }}
                                                    enableCheckValid
                                                    type={KTFormInputType.currency}
                                                    placeholder={'Nhập số'}
                                                    isValid={_.isEmpty(meta.error)}
                                                    isTouched={meta.touched}
                                                    feedbackText={meta.error}
                                                />
                                            );
                                        }}
                                    </FastField>
                                }
                            // isRequired={true}
                            />
                        </Col>

                        <Col md={5} className="pr-5">
                            <div className="d-flex gap-3 align-items-center">
                                <KTFormGroup
                                    label={
                                        <span
                                            className="font-weight-boldest"
                                            style={{
                                                fontSize: 13,
                                                color: AppColors.gray[800],
                                            }}
                                        >
                                            {t('Thưởng thêm')}
                                        </span>
                                    }
                                    inputName={`saleCommission[${index + 1}].discount`}
                                    additionalClassName=" mb-3 flex-grow-1"
                                    inputElement={
                                        <FastField name={`saleCommission[${index + 1}].discount`}>
                                            {({ field, form, meta }) => {
                                                return (
                                                    <KTFormInput
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={(value) => {
                                                            form.setFieldValue(field.name, value);
                                                        }}
                                                        onBlur={() => {
                                                            form.setFieldTouched(field.name, true);
                                                        }}
                                                        enableCheckValid
                                                        type={KTFormInputType.number}
                                                        placeholder={'Nhập số'}
                                                        isValid={_.isEmpty(meta.error)}
                                                        isTouched={meta.touched}
                                                        feedbackText={meta.error}
                                                        unit="%"
                                                    />
                                                );
                                            }}
                                        </FastField>
                                    }
                                // isRequired={true}
                                />

                                <KTBSButton
                                    size={KTBSButtonSize.medium}
                                    color={KTBSButtonColor.secondary}
                                    type={KTBSButtonType.default}
                                    iconElement={
                                        <i
                                            className="fa-regular fa-trash-can"
                                            style={{ fontSize: 15 }}
                                        />
                                    }
                                    iconOnly
                                    borderRadius={5}
                                    onPress={() =>
                                        handleDeleteSaleCommission(
                                            discount.id,
                                            formikProps.values,
                                            formikProps.setFieldValue
                                        )
                                    }
                                    additionalClassName="mt-4"
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            ))}
            <Row>
                <Col
                    md={1}
                    style={{ paddingLeft: 15 }}
                    className="d-flex align-items-center mb-4 mt-1"
                >
                    <KTBSButton
                        title={t('add')}
                        size={KTBSButtonSize.medium}
                        color={KTBSButtonColor.secondary}
                        type={KTBSButtonType.default}
                        iconElement={
                            <i className="fa-regular fa-plus" style={{ fontSize: 15 }} />
                        }
                        additionalClassName="font-weight-bolder py-3 px-6"
                        borderRadius={5}
                        onPress={() =>
                            handleAddSaleCommission(
                                formikProps.values,
                                formikProps.setFieldValue
                            )
                        }
                        buttonTitleColor={AppColors.gray[800]}
                        buttonTitleFontWeight={600}
                        buttonTitleFontSize={14}
                    />
                </Col>
            </Row>
            <Col md={12}>
                <div
                    className="my-2"
                    style={{
                        borderBottom: `1px dashed ${AppColors.gray[300]}`,
                    }}
                />
            </Col>
            <Col md={12}>
                <Modal.Title className="mb-3 mt-5 d-flex gap-2 align-items-center">
                    <span
                        className="font-weight-bolder"
                        style={{ fontSize: 18, color: AppColors.gray[900] }}
                    >
                        Hoa hồng tiền điện nhượng quyền
                    </span>
                    {UIHelper.buildToggleSwitch(isEnergyCommissionOn, handleToggle)}
                </Modal.Title>
            </Col>
            <Col md={6} className="pr-0">
                <KTFormGroup
                    label={
                        <span
                            className="font-weight-boldest"
                            style={{
                                fontSize: 13,
                                color: AppColors.gray[800],
                            }}
                        >
                            {t('commissionMode')}{' '}
                        </span>
                    }
                    inputName="energySalesCommissionMode"
                    additionalClassName=" mb-0"
                    inputElement={
                        <Field name="energySalesCommissionMode">
                            {({ field, form, meta }) => (
                                <KTBSDropdown
                                    toggleElement={
                                        <button
                                            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between dropdown-disabled"
                                            type="button"
                                        >
                                            {field.value?.length
                                                ? t(`energyCommissionMode_${field.value}`)
                                                : t(`energyCommissionMode_${commissionModeList?.[0]}`)}
                                        </button>
                                    }
                                    selectedValue={field.value}
                                    dropdownMenuItems={commissionModeList?.map(
                                        (commissionMode) => ({
                                            name: t(`energyCommissionMode_${commissionMode}`),
                                            value: commissionMode,
                                        })
                                    )}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                    onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                        handleSetCommissionUnit(value);
                                    }}
                                    onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                    }}
                                    enableCheckValid
                                    isValid={_.isEmpty(meta.error)}
                                    isTouched={meta.touched}
                                    feedbackText={meta.error}
                                    isDropdownForm={true}
                                    disabled={true}
                                />
                            )}
                        </Field>
                    }
                    isRequired={isEnergyCommissionOn}
                />
            </Col>
            <Col md={2} className="pr-0">
                <KTFormGroup
                    label={
                        <span
                            className="font-weight-boldest"
                            style={{
                                fontSize: 13,
                                color: AppColors.gray[800],
                            }}
                        >
                            {t('commissionAmount')}{' '}
                        </span>
                    }
                    inputName='energySalesCommissionValue'
                    additionalClassName=" mb-0"
                    inputElement={
                        <Field name="energySalesCommissionValue">
                            {({ field, form, meta }) => {
                                const value = field.value;
                                const isOn = isEnergyCommissionOn;
                                const unit = commissionUnit;

                                const isFieldValid = !isOn || (
                                    value !== undefined &&
                                    value !== null &&
                                    value !== '' &&
                                    (unit === '%' ? value <= 100 : value > 0)
                                );

                                return (
                                    <KTFormInput
                                        name={field.name}
                                        value={value ?? ''}
                                        onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                        }}
                                        onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                            form.validateField(field.name);
                                        }}
                                        enableCheckValid
                                        type={KTFormInputType.currency}
                                        unit={unit}
                                        placeholder="Nhập số"
                                        isValid={isFieldValid}
                                        isTouched={meta.touched}
                                        feedbackText={
                                            !isFieldValid
                                                ? (value === undefined || value === null || value === ''
                                                    ? 'Bắt buộc'
                                                    : 'Không hợp lệ')
                                                : ''
                                        }
                                        disabled={!isEnergyCommissionOn}
                                    />
                                );
                            }}
                        </Field>
                    }
                    isRequired={isEnergyCommissionOn}
                />
            </Col>
            <Col md={2} className="pr-0">
                <KTFormGroup
                    label={
                        <span
                            className="font-weight-boldest"
                            style={{
                                fontSize: 13,
                                color: AppColors.gray[800],
                            }}
                        >
                            {t('commissionDuration')}{' '}
                        </span>
                    }
                    inputName="energyCommissionDuration"
                    additionalClassName=" mb-0"
                    inputElement={
                        <Field name="energyCommissionDuration">
                            {({ field, form, meta }) => {
                                return (
                                    <KTFormInput
                                        name={field.name}
                                        value={field.value}
                                        onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                        }}
                                        onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                        }}
                                        enableCheckValid
                                        type={KTFormInputType.number}
                                        unit="Tháng"
                                        placeholder={'Nhập số'}
                                        isValid={!isEnergyCommissionOn || isEnergyCommissionOn && !!field.value}
                                        isTouched={meta.touched}
                                        feedbackText={!(!isEnergyCommissionOn || isEnergyCommissionOn && !!field.value) && 'Bắt buộc'}
                                        disabled={!isEnergyCommissionOn}
                                    />
                                )
                            }}
                        </Field>
                    }
                    isRequired={isEnergyCommissionOn}
                />
            </Col>
            <Col md={2}>
                {UIHelper.buildFormLabel('Trạm sạc áp dụng', isEnergyCommissionOn, true, 'mb-2')}
                {dropdownChargeStationEl}
            </Col>
        </Row>
    )
}

export default SaleCommissionView;